import BASE_CONFIG, { type AppConfig } from '../config.base';

const devConfig = {
  services: {
    account: {
      ...BASE_CONFIG.services.account,
      baseUrl: 'https://forbusiness-api-nonprod.geappliances.com/account-dev',
    },
    user: {
      ...BASE_CONFIG.services.user,
      baseUrl:
        'https://forbusiness-api-nonprod.geappliances.com/userAccount-dev',
    },
    order: {
      ...BASE_CONFIG.services.order,
      baseUrl: 'https://forbusiness-api-nonprod.geappliances.com/order-dev',
    },
    finance: {
      ...BASE_CONFIG.services.finance,
      baseUrl: 'https://forbusiness-api-nonprod.geappliances.com/finance-dev',
    },
    product: {
      ...BASE_CONFIG.services.product,
      baseUrl: 'https://forbusiness-api-nonprod.geappliances.com/product-dev',
    },
    shopping: {
      ...BASE_CONFIG.services.shopping,
      baseUrl: 'https://forbusiness-api-nonprod.geappliances.com/shopping-dev',
    },
    customerNetSpringBoot: {
      ...BASE_CONFIG.services.customerNetSpringBoot,
      baseUrl: 'https://customernetapi-qa.geappliances.com/api/cnet',
    },
    customerNetCustomer: {
      ...BASE_CONFIG.services.customerNetCustomer,
      baseUrl: 'https://cnet.api.geappliances.io/customers-qa',
    },
    customerNetProduct: {
      ...BASE_CONFIG.services.customerNetProduct,
      baseUrl: 'https://cnet.api.geappliances.io/products-qa',
    },
    customerNetUser: {
      ...BASE_CONFIG.services.customerNetUser,
      baseUrl: 'https://cnet.api.geappliances.io/users-qa',
    },
    customerNetOrder: {
      ...BASE_CONFIG.services.customerNetOrder,
      baseUrl: 'https://cnet.api.geappliances.io/orders-qa',
    },
    customerNetReports: {
      ...BASE_CONFIG.services.customerNetReports,
      baseUrl: 'https://cnet.api.geappliances.io/reports-qa',
    },
    customerNetPartsSpringBoot: {
      ...BASE_CONFIG.services.customerNetPartsSpringBoot,
      baseUrl: 'https://partsnetapi-qa.geappliances.com/api/pnet',
    },
  },
  integrations: {
    ...BASE_CONFIG.integrations,
    customernetUrl: 'https://customernet-qa.geappliances.com',
    legacyLoginUrl:
      'https://ssononprod.geappliances.com/samlp/Z8eVU98y5Tvd95TK1Ut2MPrtTR41Fi51',
    legacyLogoutUrl:
      'https://ssononprod.geappliances.com/v2/logout?client_id=Z8eVU98y5Tvd95TK1Ut2MPrtTR41Fi51&returnTo=https://forbusiness-stg.geappliances.com',
    oktaLoginUrl:
      'https://geappliances.okta.com/app/geappliances_forbusinessdev_1/exk10y4m3f0CHEQrP698/sso/saml',
    botIframeUrl: 'https://customer360-dev.geappliances.com',
    cyberSource: {
      requestToUrl: 'https://testsecureacceptance.cybersource.com/token/create',
      responseToUrl:
        'https://cnet.api.geappliances.io/node-qa/response?sourceSystem=dpm',
      accessKey: '3d29ec53617b3959b70238ff01d9f75f',
      profileId: 'EC265CDE-05C0-42CB-9A14-8E9607E01A00',
    },
  },
  constants: {
    pricingJobIntervalDays: 7,
    dpmData: {
      fallbackAccountNumber: '121846403',
      fallbackSalesAgreementNumber: 223799,
    },
  },
  assets: {
    ...BASE_CONFIG.assets,
  },
} satisfies AppConfig;

export default devConfig;
